<template>
  <div>
    <Form ref="employeesForm" :model="employees" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100">
      <input v-model="employees.id" type="hidden"/>

      <FormItem  :label="this.$t('property.employees.employeesNo.label')" prop="employeesNo">
        <Input v-model="employees.employeesNo" :placeholder="$t('property.employees.employeesNo.holder')"/>
      </FormItem>

      <FormItem  :label="this.$t('property.employees.name.label')" prop="name">
        <Input v-model="employees.name" :placeholder="$t('property.employees.name.holder')"/>
      </FormItem>

      <FormItem prop="imgPath" label="上传图片">
        <Input type="text" v-model="employees.pic" placeholder="照片" style="display:none">
        </Input>
        <Row type="flex" justify="start" align="middle">
          <img :src="imageUrl"
               style="width:32px;height:32px;background: #619fe7;margin: 0 10px;border-radius:50%;">
          <Button type="primary" shape="circle" icon="md-add" @click="showModal()"></Button>
        </Row>
      </FormItem>

      <!--<FormItem  :label="this.$t('property.employees.pic.label')" prop="pic">
        <Input v-model="employees.pic" :placeholder="$t('property.employees.pic.holder')"/>
      </FormItem>-->

      <FormItem  :label="this.$t('property.employees.telephone.label')" prop="telephone">
        <Input v-model="employees.telephone" :placeholder="$t('property.employees.telephone.holder')"/>
      </FormItem>

      <FormItem  :label="this.$t('property.employees.address.label')" prop="address">
        <Input v-model="employees.address" :placeholder="$t('property.employees.address.holder')"/>
      </FormItem>

      <FormItem  :label="this.$t('property.employees.jobName.label')" prop="jobId">
        <Select v-model="employees.jobId" filterable placeholder="请选择岗位信息">
          <Option  v-for="item in model12" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <!--<InputNumber v-model="employees.jobId" :placeholder="$t('property.employees.jobId.holder')"/>-->
      </FormItem>
    </Form>
    <Modal title="设置头像" v-model="modalShow" :mask-closable="false" :closable="false"
           class-name="vertical-center-modal" width="50%">
      <Row :gutter="10" class="image-editor">
        <Col span="14" class="image-editor-con1">
          <div class="cropper" style="max-height:100%;">
            <img id="cropimg1" alt="">
          </div>
        </Col>
        <Col span="10" class="image-editor-con1">
          <Row type="flex" justify="center" align="middle" class="image-editor-con1-preview-con">
            <div id="preview1"></div>
          </Row>
          <div class="image-editor-con1-btn-con margin-top-10">
            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg"
                   @change="handleChange1"
                   id="fileinput1" class="fileinput" />
            <label class="filelabel" for="fileinput1">
              <Icon type="md-image" size="20"></Icon>&nbsp;选择图片
            </label>
            <ButtonGroup style="margin-left: 16px;">
              <Button @click="cropper1.zoom(0.1)" type="primary">
                <Icon :size="14" type="md-add"></Icon>
              </Button>
              <Button @click="cropper1.zoom(-0.1)" type="primary">
                <Icon :size="14" type="md-remove"></Icon>
              </Button>
            </ButtonGroup>
          </div>
        </Col>
      </Row>
      <div slot="footer">
        <Row type="flex" justify="end">
          <Button type="default" @click="handleCancelCrop">取消</Button>
          <Button type="primary" @click="handlecrop1">确定</Button>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from '@/api'
import Cropper from 'cropperjs'

export default {
  data () {
    return {
      cropper1: {},
      modalShow: false,
      model12: [],
      imageUrl: '',
      option1: {
        showCropedImage: false,
        cropedImg: ''
      },
      employees: {
        id: null,
        employeesNo: null,
        name: null,
        pic: null,
        telephone: null,
        address: null,
        jobId: []
      },
      loading: false,
      actionType:'add',
      cropdata1: {
        x: '',
        y: '',
        w: '',
        h: '',
        deg: '',
        scaleX: '',
        scaleY: ''
      }
    }
  },
  created(){
    this.handleJobList()
  },
  methods: {
    dataURLtoFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    handlecrop1 () {
      if (!this.cropper1.getCroppedCanvas()) {
        return
      }
      let file = this.cropper1.getCroppedCanvas().toDataURL()
      if (file.length > 2048 * 1024) {
        this.$Message.warning('选择的区域太大，超过了2M。请缩小选择区域！')
        return
      }
      this.option1.cropedImg = file;
      this.imageUrl = file;
      var filename = new Date().getTime()+'.jpg';
      var urLtoFile = this.dataURLtoFile(file,filename);
      console.log(urLtoFile);
      let data = new FormData();
      data.append('file',urLtoFile); //如果还有其他参数复制就行了
      api.property.Employees.uploadFile(data)
        .then(response => {
          if (response.code==200){
            this.loading = false;
            this.employees.pic = response.msg;
            this.$Message.success(this.$t('successText'))
          }else {
            this.$Message.error("提交失败！");
          }
        })
        .catch(e => {
          this.loading = false;
        })
      this.modalShow = false
    },
    handleCancelCrop () {
      this.modalShow = false
    },
    handleChange1 (e) {
      let file = e.target.files[0]
      let reader = new FileReader()
      reader.onload = () => {
        this.cropper1.replace(reader.result)
        reader.onload = null
      }
      reader.readAsDataURL(file)
    },
    showModal () {
      this.modalShow = true
    },
    /*handleAvatarSuccess (response, file, fileList) {
      console.log(response)
      debugger;
      // this.employees.pic = response.msg;
      // this.imageUrl = `/api/property/employees/download?name=${response.data}`;
    },*/
    /*beforeUpload (file) {
      this.loading=false;
      if(file){
        const suffix = file.name.split('.')[1]
        const size = file.size / 1024 / 1024 < 2
        if(['png','jpeg','jpg'].indexOf(suffix) < 0){
          this.$Message.error('上传图片只支持 png、jpeg、jpg 格式！')
          this.$refs.upload.clearFiles()
          return false
        }
        if(!size){
          this.$Message.error('上传文件大小不能超过 2MB!')
          return false
        }
        return file
      }
    },*/
    handleSubmit(then,error){
      this.$refs['employeesForm'].validate(valid => {
        if (valid) {
          if (this.employees.id) {
            this.updateEmployees(this.employees).then(then).error(error)
          } else {
            this.createEmployees(this.employees).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleJobList(){
      this.loading = true;
      api.property.Employees.listJobInfo()
        .then(data=>{
          this.model12 = data;
          //this.employees.jobId = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handleReset(){
      this.employees.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['employeesForm'].resetFields());
      this.handleJobList()
    },
    getEmployees(id,type){
      this.loading = true;
      this.$refs['employeesForm'].resetFields()
      api.property.Employees.detail(id).then(data => {
        //console.log(data)
        this.employees.id = data.id;
        this.employees.name = data.name;
        this.employees.employeesNo = data.employeesNo;
        this.employees.pic = data.pic;
        this.employees.telephone = data.telephone;
        this.employees.address = data.address;
        this.employees.jobId = data.jobId
        this.handleJobList()
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createEmployees(employees){
      this.loading = true;
      return api.property.Employees.add(employees)
        .then(response => {
          this.loading = false;
          this.$Message.success(this.$t('successText'))
          return response;
        })
        .catch(e => {
          this.loading = false;
        })
    },
    updateEmployees(employees){
      this.loading = true;
      return api.property.Employees.update(employees)
        .then(response => {
          this.loading = false;
          this.$Message.success(this.$t('successText'))
          return response;
        })
        .catch(e => {
          this.loading = false;
        })
    }
  },
  mounted () {
    let img1 = document.getElementById('cropimg1')
    this.cropper1 = new Cropper(img1, {
      dragMode: 'move',
      preview: '#preview1',
      restore: false,
      center: false,
      highlight: false,
      aspectRatio: 1,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: true
    })
    img1.addEventListener('crop', e => {
      this.cropdata1.x = parseInt(e.detail.x)
      this.cropdata1.y = parseInt(e.detail.y)
      this.cropdata1.w = parseInt(e.detail.width)
      this.cropdata1.h = parseInt(e.detail.height)
      this.cropdata1.deg = parseInt(e.detail.rotate)
      this.cropdata1.scaleX = parseInt(e.detail.scaleX)
      this.cropdata1.scaleY = parseInt(e.detail.scaleY)
    })
  },
  computed: {
    ruleValidate(){
      let validate =  {
        employeesNo: [{type: 'string', required: true, message: this.$t('property.employees.employeesNo.required'),trigger: 'blur'}, {type: 'string',max: 50, message: this.$t('property.employees.employeesNo.max'),trigger: 'blur'}],
        name: [{type: 'string', required: true, message: this.$t('property.employees.name.required'),trigger: 'blur'}, {type: 'string',max: 20, message: this.$t('property.employees.name.max'),trigger: 'blur'}],
        pic: [{type: 'string',max: 255, message: this.$t('property.employees.pic.max'),trigger: 'blur'}],
        telephone: [{type: 'string',max: 25, message: this.$t('property.employees.telephone.max'),trigger: 'blur'}],
        address: [{type: 'string',max: 255, message: this.$t('property.employees.address.max'),trigger: 'blur'}],
        //jobId: [{type: 'number', required: true, message: this.$t('property.employees.jobId.required'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['employeesForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
